import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { PublicPolicyView } from "@/components/policies/public-policy-view";

type PolicySearch = { lang: "ar" | "en" };

export const Route = createFileRoute("/policy/$slug")({
  validateSearch: (search: Record<string, unknown>): PolicySearch => ({
    lang: search.lang === "en" ? "en" : "ar",
  }),
  component: PolicySlugPage,
});

function PolicySlugPage() {
  const { slug } = Route.useParams();
  const { lang } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <PublicPolicyView
      slug={slug}
      lang={lang}
      onLang={(next) => {
        void navigate({ to: "/policy/$slug", params: { slug }, search: { lang: next } });
      }}
    />
  );
}
